import React from 'react';
import { Container } from 'react-bootstrap';
import Header from './Header';
import Footer from './footer';

const PlatformPage = () => {
    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />

            <div style={{ flexGrow: 1, paddingTop: '120px', paddingBottom: '60px' }}>
                <Container
                    style={{
                        backgroundColor: 'white',
                        padding: '40px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
                        maxWidth: '900px',
                        margin: '0 auto'
                    }}
                >
                    <h2 style={{ textAlign: 'center', marginBottom: '10px', color: '#009fe3', fontWeight: 'bold', fontSize: '2.5rem' }}>
                        Engenheiros4IU
                    </h2>
                    <p style={{ textAlign: 'center', marginBottom: '40px', color: '#555', fontSize: '1.2rem', fontStyle: 'italic' }}>
                        Engenharia ao serviço da sociedade
                    </p>

                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                        O Engenheiros4IU é uma plataforma digital que liga associações sem fins lucrativos a engenheiros e estudantes voluntários, facilitando o desenvolvimento de soluções técnicas para desafios sociais reais. Através da app, as associações transformam as suas necessidades em projetos técnicos e pessoas com competências em engenharia colocam o seu conhecimento ao serviço do bem comum.
                    </p>

                    <h3 style={{ color: '#0056b3', marginTop: '40px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
                        Como funciona o Engenheiros4IU
                    </h3>

                    <h4 style={{ color: '#009fe3', marginTop: '20px' }}>1. A associação descreve o desafio</h4>
                    <p>
                        As associações submetem, na app, um <strong>desafio técnico</strong> (por exemplo: digitalização de processos, desenvolvimento de ferramentas simples, planeamento técnico, otimização de recursos ou apoio em engenharia aplicada).<br />
                        A plataforma orienta a submissão com perguntas claras para:
                    </p>
                    <ul>
                        <li>definir o problema,</li>
                        <li>clarificar objetivos,</li>
                        <li>indicar o tipo de competências necessárias,</li>
                        <li>estimar esforço e prazo.</li>
                    </ul>

                    <h4 style={{ color: '#009fe3', marginTop: '30px' }}>2. A equipa forma-se</h4>
                    <p>
                        O Engenheiros4IU cruza automaticamente:
                    </p>
                    <ul>
                        <li>competências técnicas,</li>
                        <li>disponibilidade,</li>
                        <li>interesses dos voluntários.</li>
                    </ul>
                    <p>
                        As equipas podem integrar <strong>engenheiros e estudantes</strong>, promovendo aprendizagem prática e colaboração intergeracional, sem relações formais de mentoria.
                    </p>

                    <h4 style={{ color: '#009fe3', marginTop: '30px' }}>3. O projeto desenvolve-se</h4>
                    <p>Durante o projeto:</p>
                    <ul>
                        <li>a equipa colabora de forma autónoma,</li>
                        <li>a associação acompanha e valida decisões-chave,</li>
                        <li>o progresso é registado de forma simples na app.</li>
                    </ul>
                    <p>
                        A plataforma estrutura o trabalho sem burocracia excessiva, respeitando o caráter voluntário e flexível da participação.
                    </p>

                    <h4 style={{ color: '#009fe3', marginTop: '30px' }}>4. Entrega e impacto</h4>
                    <p>No final do projeto:</p>
                    <ul>
                        <li>a solução é entregue à associação,</li>
                        <li>o trabalho é documentado,</li>
                        <li>o impacto é contabilizado e visível no dashboard coletivo e individual.</li>
                    </ul>
                    <p>Cada projeto concluído gera <strong>valor social mensurável</strong>, experiência prática e contributo cívico.</p>

                    <h3 style={{ color: '#0056b3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
                        Para quem é o Engenheiros4IU?
                    </h3>

                    <h4 style={{ marginTop: '20px', color: '#009fe3' }}> Associações e organizações sociais</h4>
                    <ul>
                        <li>Acesso a competências técnicas qualificadas.</li>
                        <li>Redução de custos e barreiras à inovação.</li>
                        <li>Soluções ajustadas à sua realidade.</li>
                        <li>Apoio técnico que de outra forma não estaria disponível.</li>
                    </ul>

                    <h4 style={{ marginTop: '20px', color: '#009fe3' }}> Estudantes</h4>
                    <ul>
                        <li>Experiência prática aplicada a problemas reais.</li>
                        <li>Desenvolvimento de competências técnicas e transversais.</li>
                        <li>Construção de portefólio.</li>
                        <li>Participação em projetos com impacto social.</li>
                    </ul>

                    <h4 style={{ marginTop: '20px', color: '#009fe3' }}> Engenheiros e profissionais</h4>
                    <ul>
                        <li>Aplicação do conhecimento técnico ao serviço da comunidade.</li>
                        <li>Participação flexível, por projeto.</li>
                        <li>Reconhecimento do contributo através do impacto visível na app.</li>
                    </ul>

                    <h3 style={{ color: '#0056b3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
                        O impacto que criamos
                    </h3>
                    <p>Na app, todos podem acompanhar:</p>
                    <ul>
                        <li>projetos concluídos,</li>
                        <li>número de horas voluntárias,</li>
                        <li>valor social estimado criado,</li>
                        <li>associações apoiadas,</li>
                        <li>envolvimento de estudantes e diversidade dos participantes (dados agregados).</li>
                    </ul>

                    <h3 style={{ color: '#0056b3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
                        O que torna um desafio adequado?
                    </h3>
                    <p>Para maximizar o sucesso dos projetos, recomenda-se que as associações tenham:</p>
                    <ul>
                        <li>Objetivos claros, mesmo que simples;</li>
                        <li>Flexibilidade temporal;</li>
                        <li><strong>Um ponto de contacto</strong> para acompanhar o projeto;</li>
                        <li>Capacidade de usar e manter a solução após a entrega.</li>
                    </ul>

                    <h3 style={{ color: '#0056b3', marginTop: '50px', marginBottom: '20px', borderBottom: '2px solid #0056b3', paddingBottom: '10px' }}>
                        Uma plataforma aberta e contínua:
                    </h3>
                    <p>O Engenheiros4IU não funciona por "edições" nem por ciclos:</p>
                    <ul>
                        <li>os desafios podem ser submetidos ao longo do ano;</li>
                        <li>as equipas formam-se dinamicamente;</li>
                        <li>o impacto cresce de forma contínua.</li>
                    </ul>

                    <div style={{ backgroundColor: '#e3f2fd', padding: '40px 30px', borderRadius: '8px', textAlign: 'center', marginTop: '50px', borderLeft: '6px solid #009fe3' }}>
                        <h3 style={{ color: '#0d47a1', marginBottom: '30px' }}>Junta-te ao Engenheiros4IU</h3>

                        {/* Secção das Associações */}
                        <div style={{ marginBottom: '40px' }}>
                            <p style={{ fontWeight: 'bold', color: '#0056b3', fontSize: '1.2rem', marginBottom: '15px' }}>
                             Sou uma associação e tenho um desafio técnico
                            </p>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.socialite.lct.esfa"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-block',
                                    backgroundColor: '#0056b3',
                                    color: 'white',
                                    padding: '10px 20px',
                                    borderRadius: '6px',
                                    textDecoration: 'none',
                                    fontWeight: 'bold',
                                    margin: '5px'
                                }}
                            >
                                Descarregar App Associações (Google Play)
                            </a>
                            <a
                                href="https://apps.apple.com/pt/app/esf-associa%C3%A7%C3%B5es/id6504824800"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-block',
                                    backgroundColor: '#333',
                                    color: 'white',
                                    padding: '10px 20px',
                                    borderRadius: '6px',
                                    textDecoration: 'none',
                                    fontWeight: 'bold',
                                    margin: '5px'
                                }}
                            >
                                Descarregar App Associações (App Store)
                            </a>
                        </div>

                        {/* Secção dos Voluntários */}
                        <div>
                            <p style={{ fontWeight: 'bold', color: '#0056b3', fontSize: '1.2rem', marginBottom: '15px' }}>
                             Quero participar como engenheiro ou estudante
                            </p>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.socialite.lct.esf"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-block',
                                    backgroundColor: '#009fe3', // Tom de azul ligeiramente diferente para distinguir
                                    color: 'white',
                                    padding: '10px 20px',
                                    borderRadius: '6px',
                                    textDecoration: 'none',
                                    fontWeight: 'bold',
                                    margin: '5px'
                                }}
                            >
                                Descarregar App Voluntários (Google Play)
                            </a>
                            <a
                                href="https://apps.apple.com/pt/app/esf/id6738280971"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: 'inline-block',
                                    backgroundColor: '#555', // Cinza ligeiramente diferente
                                    color: 'white',
                                    padding: '10px 20px',
                                    borderRadius: '6px',
                                    textDecoration: 'none',
                                    fontWeight: 'bold',
                                    margin: '5px'
                                }}
                            >
                                Descarregar App Voluntários (App Store)
                            </a>
                        </div>
                    </div>


                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default PlatformPage;
